<template>
  <div class="footer">
    <div class="footer-list">
      <div class="line-1">
        <div class="item item-1">
          <img src="../../assets/images/address.png" />
          <span></span>
        </div>
        <div class="item item-2">
          <img src="../../assets/images/email.png" />
          <span></span>
        </div>
        <div class="item item-3">
          <img src="../../assets/images/tel.png" />
          <span></span>
        </div>
      </div>
      <!-- <div class="line-2">
        <span>法律声明</span>
        <span>免责声明</span>
      </div> -->
      <div class="line-3">
        <span class="item-1">北京凯泰铭科技文化发展有限公司 版权所有</span>
        <span class="item-1">COPYRIGHT © 2019 凯泰铭 ALL RIGHTS RESERVED
          <!-- 赵佳佳添加  京公网安备-->
          <img src="~@/assets/images/J-bah.png" alt="">
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502043777" target="_blank">京公网安备 11010502043777号</a>
          &nbsp;&nbsp;
          <a href="https://beian.miit.gov.cn" target="_blank">京ICP备19005683号-1</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";

.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  // height: 200px;
  // height: auto;
  // margin-top: 50px;
  font-size: 0.06rem;
  background: #20252b;
  color: #ffffff;
  padding-top: 40px;
  padding-bottom: 40px;

  > .footer-list {
    width: $SIZE_PAGE_WIDTH;
    display: flex;
    flex-direction: column;
    align-items: center;

    > .line-1 {
      display: flex;
      justify-content: space-between;
      padding-bottom: 46px;
      width: 100%;
      /* transform: scale(0.9); */

      img {
        margin-right: 5px;
      }

      > * {
        display: flex;
        align-items: center;
        // transform: scale(0.9);
      }

      > .item {
        width: 33%;
      }

      > .item-1 {
        justify-content: flex-start;
        margin-right: 10px;

        > span::after {
          content: $TEXT_Address;
        }
      }
      > .item-2 {
        justify-content: center;
        margin-right: 10px;

        > span::after {
          content: $TEXT_email;
        }
      }
      > .item-3 {
        justify-content: flex-end;
        > span::after {
          content: $TEXT_Phone;
        }
      }
    }

    > .line-2 {
      display: flex;
      justify-content: center;
      padding-bottom: 20px;

      & > :first-child {
        margin-right: 10px;
      }
    }

    > .line-3 {
      display: flex;
      justify-content: center;
      flex-direction: column;
      line-height: 30px;
      opacity: 0.6;

      a {
        color: #0092d8;
      }

      > .item-1,
      > .item-2 {
        align-self: center;
      }
    }
  }
}
</style>